const formatTime = 'YYYY-MM-DD HH:mm:ss';
const formatYear = 'YYYY';
const formatDateDisplay = 'HH:mm DD-MM-YYYY';
export { formatTime, formatYear, formatDateDisplay };
